module.exports = __webpack_public_path__ + "assets/shipping.ef303f4b.svg";